var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { StudyTranslationLanguage } from "healthex-common/study-translation-language.dtos";
import { asEnum } from "healthex-common/utils";
import { IsDate } from "class-validator";
import { instanceToPlain, plainToInstance, Type } from "class-transformer";
export class ClearFallbackData {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], ClearFallbackData.prototype, "fallbackLastUsedAt", void 0);
export class Persistence {
    setTokenInfo(tokenInfo) {
        if (tokenInfo) {
            localStorage.setItem("tokenInfo", JSON.stringify(tokenInfo));
        }
        else {
            localStorage.removeItem("tokenInfo");
        }
    }
    getTokenInfo() {
        const tokenInfoString = localStorage.getItem("tokenInfo");
        return tokenInfoString ? JSON.parse(tokenInfoString) : null;
    }
    setRememberedLoginData(rememberedLoginData) {
        if (rememberedLoginData) {
            localStorage.setItem("rememberedLoginData", JSON.stringify(rememberedLoginData));
        }
        else {
            localStorage.removeItem("rememberedLoginData");
        }
    }
    getRememberedLoginData() {
        const rememberedLoginDataString = localStorage.getItem("rememberedLoginData");
        return rememberedLoginDataString ? JSON.parse(rememberedLoginDataString) : null;
    }
    getSmartAuthData() {
        const smartAuthDataString = localStorage.getItem("smartAuthData");
        return smartAuthDataString ? JSON.parse(smartAuthDataString) : null;
    }
    setSmartAuthData(smartAuthData) {
        if (smartAuthData) {
            localStorage.setItem("smartAuthData", JSON.stringify(smartAuthData));
        }
        else {
            localStorage.removeItem("smartAuthData");
        }
    }
    getFacilitatedFHIRAuthData() {
        const facilitatedFHIRAuthDataString = sessionStorage.getItem("facilitatedFHIRAuthData");
        return facilitatedFHIRAuthDataString ? JSON.parse(facilitatedFHIRAuthDataString) : null;
    }
    setFacilitatedFHIRAuthData(facilitatedFHIRAuthData) {
        if (facilitatedFHIRAuthData) {
            sessionStorage.setItem("facilitatedFHIRAuthData", JSON.stringify(facilitatedFHIRAuthData));
        }
        else {
            sessionStorage.removeItem("facilitatedFHIRAuthData");
        }
    }
    setLanguage(language) {
        if (language) {
            localStorage.setItem("language", language);
        }
        else {
            localStorage.removeItem("language");
        }
    }
    getLanguage() {
        const language = localStorage.getItem("language");
        if (!language)
            return null;
        return asEnum(StudyTranslationLanguage)(language);
    }
    setEnglishStringsDownloaded(studyId) {
        localStorage.setItem(`${studyId}_english_translations_downloaded`, "true");
    }
    removeEnglishStringsDownloaded(studyId) {
        localStorage.removeItem(`${studyId}_english_translations_downloaded`);
    }
    getEnglishStringsDownloaded(studyId) {
        return !!localStorage.getItem(`${studyId}_english_translations_downloaded`);
    }
    setClearIAL2CallbackHash(callbackHash) {
        if (callbackHash) {
            sessionStorage.setItem("clear_ial2_callbackHash", callbackHash);
        }
        else {
            sessionStorage.removeItem("clear_ial2_callbackHash");
        }
    }
    getClearIAL2CallbackHash() {
        return sessionStorage.getItem("clear_ial2_callbackHash");
    }
    setPatientConsentSession(session) {
        if (session) {
            sessionStorage.setItem("patientConsentSession", JSON.stringify(session));
        }
        else {
            sessionStorage.removeItem("patientConsentSession");
        }
    }
    getPatientConsentSession() {
        const sessionString = sessionStorage.getItem("patientConsentSession");
        return sessionString ? JSON.parse(sessionString) : null;
    }
    setInMemoryLanguage(language) {
        if (language) {
            sessionStorage.setItem("inMemoryLanguage", language);
        }
        else {
            sessionStorage.removeItem("inMemoryLanguage");
        }
    }
    getInMemoryLanguage() {
        const language = sessionStorage.getItem("inMemoryLanguage");
        if (!language)
            return null;
        return asEnum(StudyTranslationLanguage)(language);
    }
    getDocumentRetrievalUIState() {
        const documentRetrievalStateString = sessionStorage.getItem("documentRetrievalState");
        return documentRetrievalStateString ? JSON.parse(documentRetrievalStateString) : null;
    }
    setDocumentRetrievalUIState(state) {
        if (state) {
            sessionStorage.setItem("documentRetrievalState", JSON.stringify(state));
        }
        else {
            sessionStorage.removeItem("documentRetrievalState");
        }
    }
    setClearFallbackData(clearFallbackData) {
        if (clearFallbackData) {
            sessionStorage.setItem("clearFallbackData", JSON.stringify(instanceToPlain(clearFallbackData)));
        }
        else {
            sessionStorage.removeItem("clearFallbackData");
        }
    }
    getClearFallbackData() {
        const clearFallbackData = sessionStorage.getItem("clearFallbackData");
        return clearFallbackData ? plainToInstance(ClearFallbackData, JSON.parse(clearFallbackData)) : null;
    }
}
